import useTranslation from 'next-translate/useTranslation';
import { CloseIcon, WomanLaptopCoffeeColorfulIcon } from 'src/themes/cosmos/icons';
import IconButton from '../IconButton';
import styles from './styles.module.scss';

export interface IHeaderProps {
  onHide: () => void;
}

const Header = ({ onHide }: IHeaderProps) => {
  const { t } = useTranslation('common');
  return (
    <div className={styles.container}>
      <header>
        <h1>{t('notes.hello')},</h1>
        <IconButton className={styles.closeButton} onClick={onHide} icon={<CloseIcon />} />
      </header>
      <div className={styles.content}>
        <p>{t('notes.description')}</p>
        <WomanLaptopCoffeeColorfulIcon />
      </div>
    </div>
  );
};

export default Header;
